import { LabelStyled } from 'components/LabelsList.style';
import styled from 'styled-components';

export const StyledGroupTitle = styled.span``;

export const StyledSelectedValuesView = styled.div`
  margin-bottom: 1rem;
  & ${LabelStyled} {
    align-items: center;
    padding-right: 1rem;
  }
  & ${StyledGroupTitle}:not(:first-child) {
    margin-left: 1rem;
  }
  svg {
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
    &#Pencil {
      margin-right: 0.5rem;
    }
  }
`;

export const StyledSelectedValueRow = styled.div``;

export const StyledOperatorWrapper = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;
